import PropTypes from 'prop-types'

import SectionFinancingTerms from '@adv-mt/mt-section-financing-legal-terms'

const PanelFinancingModalContent = ({financingInfo}) => {
  return (
    <div className="mt-PanelFinancing-modalContentLegalConditions">
      <SectionFinancingTerms financingData={financingInfo} titleSize="xs" />
    </div>
  )
}

PanelFinancingModalContent.displayName = 'PanelFinancingModalContent'

PanelFinancingModalContent.propTypes = {
  financingInfo: PropTypes.object
}

export {PanelFinancingModalContent}
